/**
 * A closed trade's identity for the trader's own tags and notes: the same key
 * the server builds (server/utils/tradeKey.js); keep the two in step. Works on
 * rows from collapseStrategies (a strategy row keys by its strategy id, a lone
 * option by its raw contract symbol).
 */
export function tradeKey(t = {}, account = t.account) {
  const what = (t.isStrategy && t.strategy?.id) || t.strategyId || t.rawSymbol || t.symbol || '';
  const num = (v) => (v == null || v === '' ? '' : String(Math.round(Number(v) * 10000) / 10000));
  return [account || '', what, String(t.entryDate || '').slice(0, 10), String(t.exitDate || '').slice(0, 10),
    String(t.side || '').toLowerCase(), num(t.quantity), num(t.entryPrice), num(t.exitPrice)].join('|');
}
